import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom';

import { Empty } from 'components';
import { Label } from 'semantic-ui-react';

import { EnumChannel } from 'enums';

import { Typeof } from 'utils';

import './style.css';

class Firmware extends React.Component {

  render() {

    const { firmware } = this.props;

    let _version = null;
    let _channel = null;

    if(Typeof.string(firmware)) {

      let groups = firmware.match(/^([0-9]+\.[0-9]+\.[0-9])_(R|D)$/);

      if(groups)
      {
        _version = groups[1];
        _channel = EnumChannel.byPrefix(groups[2]);
      }
    }

    if(Typeof.string(_version) && Typeof.string(_channel)) {

      return (
        <Link to={`/firmwares/${_channel}/${_version}`} className="firmware mono">
          <Label size="mini" color={EnumChannel.color(_channel)} image>
            {_version}
            <Label.Detail>
              {_channel}
            </Label.Detail>
          </Label>
        </Link>
      )
    }

    return <Empty />
  }
}

Firmware.propTypes = {
  firmware: PropTypes.string
};

export default Firmware;
